import { render } from "./RulesInput.vue?vue&type=template&id=21cb66c0&scoped=true"
import script from "./RulesInput.vue?vue&type=script&lang=js"
export * from "./RulesInput.vue?vue&type=script&lang=js"

import "./RulesInput.vue?vue&type=style&index=0&id=21cb66c0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21cb66c0"]])

export default __exports__